export enum TariffNameEnum {
  'Family&Friends (legacy)' = 'Family&Friends (legacy) (106)',
  'Bürgerstrom' = 'Bürgerstrom (107)',
  'Family and Friends' = 'Family and Friends (108)',
  'Natüüürlich25'= 'Natüüürlich25 (110)',
  'Füüürsorglich25'= 'Füüürsorglich25 (111)',
  'Düüünamisch24'= 'Düüünamisch24 (112)',
  'Natüüürlich15'= 'Natüüürlich15 (113)',
  'Füüürsorglich15'= 'Füüürsorglich15 (114)',
  'Bürgerstrom Geiseltal'= 'Bürgerstrom Geiseltal (115)',
  'Natüüürlich18'= 'Natüüürlich18 (116)',
  'Bürgerstrom Kleintirol'= 'Bürgerstrom Kleintirol (119)',
  'Löwenstrom'= 'Löwenstrom (120)',
  'FüüürsorglichVersprechen'= 'FüüürsorglichVersprechen (121)',
  'Natüüürlich10'= 'Natüüürlich10 (122)',
}

export default {
  TariffNameEnum,
};
